import api from 'apis/api';
import filterApiErr from 'apis/filterApiError';

export const logoutApi = async () => {
  try {
    await api.post('/api/v1/auth/revoke');
  } catch (err: any) {
    if (filterApiErr(err)) {
      // TODO: logging
      return Promise.resolve(); // Ignore any specific error
    }

    return Promise.reject();
  }
};
